import { useHistory } from 'react-router-dom'
import { makeFiltersFromUrl } from '../../utils/uri.utilities'
import { useContext } from 'react'
import { UserLocationContext } from '../../contexts/user-location-context'
import { FilterInput, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchResultsFacetsWithGroupsQueryVariables } from '../../contexts/search-results-context/query/__generated__/search-results-facets.fed.query'
const removeDistanceIfUserLocationIsGlobal = (queryFilters: FilterInput[]) => {
    const filterNames = queryFilters.map((filterInput) => filterInput.filter)
    return filterNames.includes(FilterName.distance) && filterNames.includes(FilterName.location)
        ? queryFilters.filter((filterInput) => filterInput.filter !== FilterName.distance)
        : queryFilters
}

const cleanedUpFilters = (queryFilters: FilterInput[]) =>
    removeDistanceIfUserLocationIsGlobal(queryFilters)
        .sort((a, b) => (a.filter < b.filter ? -1 : 1)) // we only sort to make the testing of gql queries easier as the MockedProvider needs arrays to be in identicial order. Not ideal, but decided was worth it compared with the pain when testing
        .filter((filter) => filter.selected && filter.selected?.length > 0) // TODO Ideally we should not commit empty values to the location state, this would prevent having to remove empty values here

const useMakeUserLocationFilter = (): FilterInput | undefined => {
    const { postcode, latLong, location } = useContext(UserLocationContext)
    if (postcode) return { filter: FilterName.postcode, selected: [postcode] }
    if (latLong) return { filter: FilterName.lat_long, selected: [latLong] }
    if (location) return { filter: FilterName.location, selected: [location] }
}

export function useQueryFilters(): SearchResultsFacetsWithGroupsQueryVariables['filters'] {
    const { location } = useHistory()
    const userLocationFilter = useMakeUserLocationFilter()

    const filtersWithoutUserLocation = makeFiltersFromUrl(location)
    const queryFilters = userLocationFilter
        ? [...filtersWithoutUserLocation, userLocationFilter]
        : filtersWithoutUserLocation

    return cleanedUpFilters(queryFilters)
}
